<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col sm="4" md="3" lg="2" xl="1" class="nav-left">
                    <SideMenu />
                </v-col>
                <v-col sm="8" md="9" lg="10" xl="11" class="nav-right mt-5 pl-xl-12">
                    <v-card width="95%" class="mx-auto pl-xl-5" elevation="0">
                        <v-card-title>
                            USUARIOS
                            <v-spacer></v-spacer>
                            <v-text-field
                                class="elevation-0"
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Buscar"
                                single-line
                                hide-details
                                @keyup.enter="loadPayments"
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                            :custom-filter="filterText"
                            :headers="headers"
                            :items="page.data"
                            sort-by="id"
                            sort-desc
                            :loading="isLoading"
                            loading-text="Cargando usuarios"
                            :no-data-text="noDataText"
                            item-key="id"
                            class="elevation-0 pa-1 mb-10"
                            style="z-index: 1000;"
                            :items-per-page="page.itemsPerPage"
                        >
                            <template v-slot:item.bucketCode="{ item }">
                                {{ getNamePack(item.bucketCode) }}
                            </template>
                            <template v-slot:item.createdAt="{ item }">
                                {{ getDateString(item.createdAt) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-icon small class="mr-2" @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon small class="mr-2" @click="areYouSureDialog(item)">
                                    mdi-delete
                                </v-icon>
                            </template>
                            <template v-slot:item.document="{ item }">
                                <v-btn
                                    text
                                    x-small
                                    color="primary"
                                    v-if="item.document !== '' && item.document !== null"
                                    @click="downloadDoc(item)"
                                >
                                    {{ item.document }}
                                </v-btn>
                            </template>
                            <template v-slot:loading>
                                <div class="loading">
                                    Cargando Usuarios...
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-snackbar v-model="snackbar" :timeout="5000" outlined color="warning" right top>
                {{ error }}
            </v-snackbar>
        </v-container>
        <AdminUserForm
            :payment="paymentItem"
            :dialog="paymentFormDialog"
            :isCreate="isCreatePayment"
            @updateItems="updateItemsList"
            @addItem="addItemToList"
            @close="closeDialogEdit"
        />
        <v-dialog width="550px" v-model="areYouSure.dialog" persistent>
            <v-card>
                <v-card-title>
                    Estas Seguro que quieres eliminar el usuario ID:
                    {{ areYouSure.item && areYouSure.item.id ? areYouSure.item.id : "" }}
                </v-card-title>
                <v-card-text>
                    Organización:
                    {{
                        areYouSure.item && areYouSure.item.user.organization
                            ? areYouSure.item.user.organization.name
                            : ""
                    }}
                    <br />
                    Usuario:
                    {{
                        areYouSure.item && areYouSure.item.user.email
                            ? areYouSure.item.user.email
                            : ""
                    }}
                </v-card-text>
                <v-card-actions class="d-flex justify-end align-center">
                    <v-btn
                        :disabled="isLoading"
                        @click="cancelDelete"
                        dark
                        color="#3BADFF"
                        small
                        text
                    >
                        CANCELAR
                    </v-btn>
                    <v-btn
                        :loading="isLoading"
                        @click="deleteItem(areYouSure.item.id)"
                        dark
                        color="#3BADFF"
                        small
                        text
                    >
                        CONFIRMAR
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Footer />
    </div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
import AdminUserForm from "@/components/AdminUserForm";
import { currentImg, datetime, handleTxt } from "@/libs/mixins";
import { packsDesc } from "@/config/fixtures";
import { mapActions } from "vuex";

export default {
    name: "AdminPayments",
    components: {
        SideMenu,
        AdminUserForm
    },
    mixins: [currentImg, datetime, handleTxt],
    data() {
        return {
            snackbar: false,
            dateFilter: {
                start: "",
                end: ""
            },
            noDataText: "No hay datos de usuario",
            isLoading: false,
            search: "",
            paymentItem: null,
            paymentFormDialog: false,
            dialogEditCreate: {
                item: {},
                dialog: false
            },
            isCreatePayment: false,
            page: {
                index: 1,
                itemsPerPage: 10,
                data: [],
                total: 0
            },
            headers: [
                {
                    text: "id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                { text: "Usuario", align: "start", value: "email" },
                { text: "Nombre", align: "start", value: "name" },
                { text: "Telefono", align: "start", value: "phone" },
                { text: "Estatus", align: "start", value: "status" },
                { text: "Rol", align: "start", value: "role" },
                { text: "Login", align: "start", value: "login" },
                { text: "Experience", align: "start", value: "experience" },
                { text: "Acciones", align: "start", value: "actions", sortable: false }
            ],
            areYouSure: {
                dialog: false,
                item: null
            },
            error: ""
        };
    },
    async created() {
        this.dateFilter.end = new Date().toISOString().slice(0, 10);
        const start = new Date();
        start.setDate(start.getDate() - 60);
        this.dateFilter.start = start.toISOString().slice(0, 10);
        await this.loadInitialPayments();
    },
    watch: {
        async "dateFilter.start"() {
            await this.loadInitialPayments();
        },
        async "dateFilter.end"() {
            await this.loadInitialPayments();
        }
    },
    computed: {
        packsDesc() {
            return [...packsDesc];
        }
    },
    methods: {
        ...mapActions("accounts", ["getPayments", "deletePayment"]),
        ...mapActions("users", ["list", "deletePayment", "test"]),
        async loadPayments() {
            try {
                this.isLoading = true;
                const searchText = this.search.trim();
                const page = this.page.index;
                const limit = this.page.itemsPerPage;
                let payments;
                if (searchText) {
                    payments = await this.test({ page, limit, searchText });
                } else {
                    payments = await this.list();
                }
                this.page.data = payments;
                if (payments.rows.length === 0) {
                    this.noDataText = "No hay datos de pago";
                }
            } catch (error) {
                this.error = error[1];
                this.snackbar = true;
            } finally {
                this.isLoading = false;
            }
        },
        async loadInitialPayments() {
            try {
                this.isLoading = true;
                const payments = await this.list();
                this.page.data = payments;
                if (payments.length === 0) {
                    this.noDataText = "No hay datos de pago";
                }
            } catch (error) {
                this.error = error[1];
                this.snackbar = true;
            } finally {
                this.isLoading = false;
            }
        },
        getNamePack(code) {
            const pack = packsDesc.find(p => p.code === code);
            return pack ? pack.name : `NON FOUND ${code}`;
        },
        getDateString(date) {
            const [year, month, day] = new Date(date)
                .toISOString()
                .slice(0, 10)
                .split("-");
            return `${day}-${month}-${year}`;
        },
        editItem(item) {
            this.isCreatePayment = false;
            this.paymentItem = item;
            this.paymentFormDialog = true;
        },
        closeDialogEdit() {
            this.paymentFormDialog = false;
            this.paymentItem = {
                bucketId: "",
                bucket: {},
                bucketCode: "",
                discountCode: "",
                document: "null",
                externalId: "",
                method: "",
                status: "",
                createdAt: ""
            };
        },
        updateItemsList(item) {
            this.page.data = this.page.data.map(i => (i.id === item.id ? { ...i, ...item } : i));
        },
        areYouSureDialog(item) {
            this.areYouSure.item = {
                ...item
            };
            this.areYouSure.dialog = true;
        },
        cancelDelete() {
            this.areYouSure.item = null;
            this.areYouSure.dialog = false;
        },
        async deleteItem(id) {
            try {
                this.isLoading = true;
                const response = await this.deletePayment(id);
                this.cancelDelete();
                this.page.data = this.page.data.filter(p => p.id !== id);
                this.isLoading = false;
            } catch (error) {
                console.error(error);
                this.cancelDelete();
                this.isLoading = false;
            }
        },
        addItemToList(item) {
            this.page.data.push(item);
        },
        filterText(value, search, item) {
            return (
                value !== null &&
                search !== null &&
                (
                    this.normalized(item.email).includes(
                        this.normalized(search)))
            );
        },
        createPayment() {
            this.isCreatePayment = true;
            this.paymentItem = {
                bucketId: "",
                bucket: {},
                bucketCode: "",
                discountCode: "",
                document: "null",
                externalId: "",
                method: "",
                status: "",
                createdAt: ""
            };
            this.paymentFormDialog = true;
        },
        downloadDoc(item) {
            const filename = item.document;
            let url =
                process.env.VUE_APP_ROOT_ASSETS +
                process.env.VUE_APP_ASSETS_INVOICE_PATH +
                filename;
            fetch(url)
                .then(res => res.blob())
                .then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = encodeURI(url);
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        }
    }
};
</script>
<style>
td {
    font-size: 12px !important;
}
.loading {
    margin-top: 20px !important;
    margin-bottom: 600px !important;
}
</style>
